import CityPage from '../../components/CityPage';

const cityData = {
    name: "Bénerville-sur-Mer",
    slug: "benerville-sur-mer",
    postalCode: "14910",
    intro: "CC Débarras 14 propose un service de débarras professionnel à Bénerville-sur-Mer. Résidences secondaires, maisons de famille, appartements : nous intervenons pour tous types de biens dans cette commune de la Côte Fleurie. Succession, vente ou déménagement — notre équipe assure le tri complet, le chargement et l'évacuation de vos affaires, dans le respect de votre bien.",
    nearby: ["Deauville", "Blonville-sur-Mer", "Tourgéville", "Saint-Arnoult", "Villers-sur-Mer"],
};

const BenervilleSurMer = () => <CityPage city={cityData} />;

export default BenervilleSurMer;
